var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"dev-eef6bfd"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser side.
// The config you add here will be used whenever a user loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

const shouldDropAxios400 = (hint?: Sentry.EventHint) => {
  const hasAxios400Status = (error: unknown): boolean => {
    if (!error || typeof error !== 'object') {
      return false
    }

    const candidate = error as {
      cause?: unknown
      isAxiosError?: boolean
      name?: string
      response?: { status?: number }
      status?: number
    }

    const statusCode = candidate.response?.status ?? candidate.status
    const isAxiosError = candidate.isAxiosError || candidate.name === 'AxiosError'

    if (isAxiosError && statusCode === 400) {
      return true
    }

    if (candidate.cause) {
      return hasAxios400Status(candidate.cause)
    }

    return false
  }

  return hasAxios400Status(hint?.originalException) || hasAxios400Status(hint?.syntheticException)
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.0005,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Performance monitoring
  environment: process.env.NODE_ENV,

  // Release 버전 - 환경변수에서 가져오기 (빌드 시 자동 설정됨)
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,

  beforeSend(event, hint) {
    if (shouldDropAxios400(hint)) {
      return null
    }

    return event
  },
})
